import { IBooking } from '../../models/IBooking';
import { fromLocalDateTime } from '../../../../../shared/i18n/date-time/LocalDateTime';
import { timeZone } from '../../../../../../config/common';
import { parseTime } from './parseTime';

export function getIsFutureBooking(booking: IBooking) {
	return (
		fromLocalDateTime({
			date: booking.parkingProductsQuote.startDate,
			time: parseTime(booking.parkingProductsQuote.startTime),
			zone: timeZone,
		}).getTime() > Date.now()
	);
}
